import { IPresentationListing } from "../../../entities-generated/models/presentation/presentation-listing";

export enum ListingContextMenuState {
  Closed,
  Opening,
  Open,
  Closing,
}
export interface IPresentationListingDisplayModel {
  presentation: IPresentationListing;
  menuState: ListingContextMenuState;
  orderValue: number;
}